import React, { useContext } from 'react';

import { FilteredBySubHeader } from 'src/modules/designStudio/components/DesignMenu/FilteredBySubHeader';
import { MenuHeader } from 'src/modules/designStudio/components/DesignMenu/Menu/MenuHeader';
import { FeatureCategories } from 'src/modules/designStudio/constants';
import { productCatalogContext } from 'src/modules/designStudio/providers';
import type { UpdateDesignFunction } from 'src/modules/designStudio/providers/HistoryProvider';
import type { LegacyDesignConfig } from 'src/modules/designStudio/types';

import { ColorList } from '../Filters';

export const TrimMenu = ({
  designConfig,
  updateDesign,
  requestingOrgName,
  headerText,
  closeMenu,
}: {
  designConfig: LegacyDesignConfig;
  updateDesign: UpdateDesignFunction;
  requestingOrgName?: string;
  headerText: string | null;
  closeMenu: () => void;
}) => {
  const { filteredColors, filterTracker } = useContext(productCatalogContext);
  const { color } = designConfig[FeatureCategories.TRIM];

  const subHeader =
    requestingOrgName && filterTracker[FeatureCategories.TRIM] ? (
      <FilteredBySubHeader companyName={requestingOrgName} />
    ) : undefined;

  return (
    <>
      <MenuHeader closeMenu={closeMenu} headerText={headerText ?? ''} />
      <ColorList
        color={color}
        colorData={filteredColors[FeatureCategories.TRIM]}
        designConfig={designConfig}
        designConfigCategory={FeatureCategories.TRIM}
        subHeader={subHeader}
        updateDesign={updateDesign}
      />
    </>
  );
};
